module.exports = __webpack_public_path__ + "img/Solanum_melongena.84858891.jpg";